import { Checkbox, Form, Input, Select } from "antd";
import { StepProps } from "./StepProps";
import { useTranslation } from "react-i18next";

const NONE_OPTION = "None";

const FourthStep: React.FC<StepProps> = () => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();

  const LabelWithInstruction = (props: any) => {
    const { label, instruction } = props;
    return (
      <div className="label-with-instruction">
        <p className="label">{label}</p>
        <p className="instruction">{instruction}</p>
      </div>
    );
  };

  const handleDeliverablesChange = (selected: string[]) => {
    const last = selected[selected.length - 1];
    if (last === NONE_OPTION) {
      form.setFieldValue("releaseMaterials", [NONE_OPTION]);
    } else {
      form.setFieldValue(
        "releaseMaterials",
        selected.filter((v: any) => v !== NONE_OPTION)
      );
    }
  };

  return (
    <div>
      <Form.Item
        name="songUrl"
        label={
          <LabelWithInstruction
            label={t("pages.Pitching.steps.fourth.songUrl")}
            instruction={t("pages.Pitching.steps.fourth.songUrlIns")}
          />
        }
        rules={[
          {
            type: "url",
            message: t("pages.Pitching.steps.fourth.urlInvalida"),
          },
          {
            required: true,
          },
        ]}
      >
        <Input
          placeholder={t("pages.Pitching.steps.fourth.songUrlPlaceHolder")}
        />
      </Form.Item>
      <Form.Item
        name="videoClipeUrl"
        label={
          <LabelWithInstruction
            label={t("pages.Pitching.steps.fourth.videoClipeUrl")}
            instruction={t("pages.Pitching.steps.fourth.videoClipeUrlIns")}
          />
        }
        rules={[
          {
            type: "url",
            message: t("pages.Pitching.steps.fourth.urlInvalida"),
          },
        ]}
      >
        <Input
          placeholder={t(
            "pages.Pitching.steps.fourth.videoClipeUrlPlaceHolder"
          )}
        />
      </Form.Item>
      <Form.Item
        name="photosURL"
        label={
          <LabelWithInstruction
            label={t("pages.Pitching.steps.fourth.photosURL")}
            instruction={t("pages.Pitching.steps.fourth.photosURLIns")}
          />
        }
        rules={[
          {
            required: true,
            message: t("pages.Pitching.steps.fourth.photosURLRequired"),
          },
          {
            type: "url",
            message: t("pages.Pitching.steps.fourth.urlInvalida"),
          },
        ]}
      >
        <Input
          placeholder={t("pages.Pitching.steps.fourth.photosURLPlaceholder")}
        />
      </Form.Item>
      <Form.Item
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.noPlanningMaterial !== currentValues.noPlanningMaterial
        }
        className="wrapper-planning-files"
      >
        {({ getFieldValue }) => (
          <Form.Item
            name="planningFilesURL"
            className={`input-planning-files ${
              getFieldValue("noPlanningMaterial") && "input-disabled"
            }`}
            label={
              <LabelWithInstruction
                label={t("pages.Pitching.steps.fourth.planningFilesURL")}
                instruction={t(
                  "pages.Pitching.steps.fourth.planningFilesURLIns"
                )}
              />
            }
            rules={
              getFieldValue("noPlanningMaterial")
                ? []
                : [
                    {
                      required: true,
                      message: t(
                        "pages.Pitching.steps.fourth.planningFilesURLInsRequired"
                      ),
                    },
                    {
                      type: "url",
                      message: t("pages.Pitching.steps.fourth.urlInvalida"),
                    },
                  ]
            }
          >
            <Input
              placeholder={t(
                "pages.Pitching.steps.fourth.planningFilesURLPlaceholder"
              )}
              disabled={getFieldValue("noPlanningMaterial")}
            />
          </Form.Item>
        )}
      </Form.Item>
      <Form.Item
        name="noPlanningMaterial"
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox>
          <span>{t("pages.Pitching.steps.fourth.noPlanningMaterial")}</span>
        </Checkbox>
      </Form.Item>
      <Form.Item
        name="releaseMaterials"
        label={t("pages.Pitching.steps.fourth.deliverables")}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          mode="multiple"
          onChange={handleDeliverablesChange}
          options={[
            {
              label: t("pages.Pitching.steps.fourth.lyrics"),
              value: "Letra da música",
            },
            {
              label: t("pages.Pitching.steps.fourth.motionArtwork"),
              value: "Arte animada",
            },
            {
              label: t("pages.Pitching.steps.fourth.spatialAudio"),
              value: "Áudio espacial",
            },
            {
              label: t("pages.Pitching.steps.fourth.noneOptions"),
              value: NONE_OPTION,
            },
          ]}
        />
      </Form.Item>
    </div>
  );
};

export default FourthStep;
